import React from 'react'
import { styled } from '@mui/material/styles'
import { Side_Margin } from '@/constant'
import { ImageIcon } from '@/icon'
import emblem from '@/asset/img/emblem.webp'

export const FooterComponent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  marginLeft: `${parseInt(Side_Margin) / 2}%`,
  marginBottom: `${parseInt(Side_Margin) / 2}%`,
  bottom: '0px',
  opacity: 0.5,
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
  },
}))

export const Icon = () => {
  return <ImageIcon src={emblem} />
}
